import { Form, Link } from "@inertiajs/react";

import TextField from "/components/TextField";
import PasswordField from "/components/TextField/PasswordField";
import Button from "/components/Button";

import styles from "/components/formStyles.module.css";

export default function SignIn({ errors = {} }) {
  return (
    <div className={styles.loginFormWrapper}>
      <Form action="/sign_in" method="POST" className={styles.loginFormContainer}>
        <h1>Sign In</h1>

        <TextField label="Email" placeholder="email@example.com" name="email" />
        <PasswordField label="Password" name="password" />

        {errors.base && (
          <ul className="errorsContainer">
            {errors.base.map(errorMessage => (
              <li>{errorMessage}</li>
            ))}
          </ul>
        )}

        <Button type="submit">Sign In</Button>
      </Form>

      <p className="muted font-small">Don't have an account? <Link href="/sign_up">Sign Up</Link></p>
    </div>
  );
}
